import { toString } from "lodash";
export var entityNormalizedField = function (fieldName) {
  return function (entity) {
    var _a;
    return (_a = toString(entity[fieldName])) === null || _a === void 0 ? void 0 : _a.replace(/[^a-zA-Z0-9]/g, '').trim();
  };
};